export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_I18_LANG = process.env.REACT_APP_I18_LANG;
export const REACT_APP_FRONTEND_ROOT = process.env.REACT_APP_FRONTEND_ROOT;
export const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api`;

// Production frontend prefix - centralized configuration
export const PRODUCTION_PREFIX =
  process.env.REACT_APP_PRODUCTION_PREFIX ||
  "/yvr1rnHJSI8hJxiyzJpq3AUaUhlZttYaCifIn2OAYqO0ZsZTl2eV4nsAOUdgdjMl";
